import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, isRef as _isRef, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fa45127"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OAtividadeNaoPlanejada__titulo" }
const _hoisted_2 = { class: "OAtividadeNaoPlanejada__Conteudo" }
const _hoisted_3 = {
  key: 1,
  class: "OAtividadeNaoPlanejada__Etapas"
}
const _hoisted_4 = {
  key: 2,
  class: "OAtividadeNaoPlanejada__SemAtributos"
}
const _hoisted_5 = { class: "OAtividadeNaoPlanejada__Projeto" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "pi pi-map" }, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "OAtividadeNaoPlanejada__SelecionarAtividade",
  "data-testid": "OAtividadeNaoPlanejada__SelecionarAtividade"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "pi pi-calendar" }, null, -1))
const _hoisted_9 = {
  key: 3,
  class: "OAtividadeNaoPlanejada__ComAtributos"
}
const _hoisted_10 = { class: "OAtividadeNaoPlanejada__Rodape" }
const _hoisted_11 = {
  key: 1,
  class: "OAtividadeNaoPlanejada__BotoesDeAcao"
}

import { MDropdown, AEtapas } from "@/components/Gerais"
  import { MFormularioAtividadeComAtributos } from "@/components/Atributos"
  import {
    ABotaoDeAcao,
  } from "@/components/Calendario"
  import AButton from "primevue/button"
  import { usarLeitorDeDados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"
  import {
    ListarProjetos,
    ParamsProjeto
  } from "@/repositorios/projeto/projeto.modelo"
  import { ProjetoRepositorio } from "@/repositorios/projeto/projeto.repositorio"
  import { EntidadeGenerica } from "@/types/gerais"
  import Dialog from "primevue/dialog"
  import { computed, onMounted, onUnmounted, ref } from "vue"
  import { storeToRefs } from "pinia"
  import { estados } from "@/types/api"
  import TiposDeAtividadeRepositorio from "@/repositorios/tiposDeAtividade/tiposDeAtividade.repositorio"
  import AtividadesRealizadasRepositorio from "@/repositorios/atividades/atividades.repositorio"
  import { usarEscritorDeDados } from "@/composable/UsarEscritorDeDados/usarEscritorDeDados"
  import { usarMensagemUsuario } from "@/composable/UsarMensagemUsuario/usarMensagemUsuario"
  import { usarBuscarMaisDados} from "@/composable/UsarBuscarMaisDados/usarBuscarMaisDados"
  import { usarDataHora } from "@/composable/UsarDataHora/usarDataHora"
  import { usarManipuladorObjetos } from "@/composable/UsarManipuladorObjetos/usarManipuladorObjetos"
  import {
    IniciarAtividadeRealizadaNaoPlanejada
  } from "@/repositorios/atividades/atividades.modelos"
  import SessaoServico from "@/servicos/sessao.service"
  import { AtributoBase } from "@/repositorios/atributos/atributos.modelos";

  import { useI18n } from "vue-i18n"
  import { ListarTiposDeAtividadeComAtributos, ParamsTiposDeAtividade } from "@/repositorios/tiposDeAtividade/tiposDeAtividade.modelo"
  import { Etapa } from "@/components/Gerais/AEtapas/AEtapas.modelos"
  import { CaracteristicaStore } from "@/store/atributos/caracteristicas/caracteristicas.store"

  interface Props {
    visibilidade: boolean
  }

  interface OpcaoAtividadeDoProjeto extends EntidadeGenerica {
    idTipoDeAtividade: string
  }

  interface Emissores {
    (event: "update:visibilidade", visibilidade: boolean): void
    (event: "update:atualizarCalendario"): void
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OIniciarAtividadeRealizadaNaoPlanejada',
  props: {
    visibilidade: { type: Boolean }
  },
  emits: ["update:visibilidade", "update:atualizarCalendario"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "update:visibilidade", visibilidade: boolean): void
    (event: "update:atualizarCalendario"): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    visibilidade: boolean
  }

  
  

  const { t } = useI18n()

  const { leitor } = usarLeitorDeDados()
  const { escritor, resolver } = usarEscritorDeDados()
  const { verificarSeElementoTemConteudo } = usarManipuladorObjetos()
  const { onSucesso, onErro, onAviso, onInfo } = usarMensagemUsuario()
  const { obterTimeZoneLocal } = usarDataHora()
  const { buscarMaisDados, filtrarDadosDoRepositorio, atualizarDadosDoRepositorio  } = usarBuscarMaisDados()
  const caracteristicaStore = CaracteristicaStore()
  const { caracteristicas } = storeToRefs(caracteristicaStore)
  
  const projetos = ref<ListarProjetos[]>([])
  const projetosMapeados = ref<EntidadeGenerica[]>([])
  const tiposDeAtividade = ref<OpcaoAtividadeDoProjeto[]>([])
  const projetoSelecionado = ref<string | null>(null)
  const tipoDeAtividadeSelecionado = ref<string | null>(null)
  const atributosEsperados = ref<AtributoBase[]>([])
  const segundaEtapaModal = ref<boolean>(false)
  const estadoDeCarregamentoIniciarAtividade = ref<number>(estados.INICIAL)
  const { id: idUsuarioLogado } = SessaoServico.coletarInformacoesDoUsuarioLogado()

  const etapas = <Etapa[]>([
    { rotulo: t('etapaAtividade') },
    { rotulo: t('etapaAtributos') }
  ])

  const etapaAtiva = ref<number>(0)

  const aoClicarNaEtapa = (indice: number) => {
    etapaAtiva.value = indice
  }

  const projetoRepositorio = new ProjetoRepositorio({ utilizaCache: true })
  const tiposDeAtividadeRepositorio = new TiposDeAtividadeRepositorio({ utilizaCache: true })

  const atividadesRealizadasRepositorio = new AtividadesRealizadasRepositorio({
    utilizaCache: true,
  })

  const escritorAtividade = escritor<
    { id: string },
    IniciarAtividadeRealizadaNaoPlanejada
  >(atividadesRealizadasRepositorio.iniciarAtividadeRealizada, [])

  const lerProjetos = leitor<ListarProjetos, ParamsProjeto>(
    projetoRepositorio.listarProjetosFrontend, {
      ativo: "igual.true",
      "por-pagina": 30,
    }
  )

  const lerTiposDeAtividadeComAtributos = leitor<ListarTiposDeAtividadeComAtributos, ParamsTiposDeAtividade>(
    tiposDeAtividadeRepositorio.listarTiposDeAtividadeFrontend
  )

  const emissorVisibilidade = computed({
    get() {
      return props.visibilidade
    },
    set(visibilidade: boolean) {
      emitir("update:visibilidade", visibilidade)
    },
  })

  const botaoSubmissorEstaDesativado = computed(() => {
    const temProjetoPreenchido = !!projetoSelecionado.value
    const temAtividadePreenchida = !!tipoDeAtividadeSelecionado.value

    if (!segundaEtapaModal.value) {
      return !temProjetoPreenchido
    }

    return !temProjetoPreenchido || !temAtividadePreenchida
  })

  const deveExibirEtapas = computed(() => {
    return temAtributos.value
  })

  const temAtributos = computed(() => {
    return atributosEsperados.value && atributosEsperados.value.length > 0 
  })

  const estaCarregandoAtributos = computed(() => {
    return (
      tipoDeAtividadeSelecionado.value !== null && 
      lerTiposDeAtividadeComAtributos.resultado.status === 'pendente'
    )
  })

  const estaCarregandoProjetos = computed(() => {
    return lerProjetos.resultado.status === 'pendente'
  })

  const estaSalvandoAtividade = computed(() => {
    return escritorAtividade.resultado.status === 'pendente'
  })

  const idDoProfissionalLogado = computed(() => {
    const profissional =
      SessaoServico.coletarInformacoesDeProfissionalDoUsuario()
    if (profissional) {
      return profissional.id
    }
    return ""
  })

  const avancarParaProximaEtapa = (): void => {
    etapaAtiva.value = 1
  }

  const desabilitarBotaoIniciarAtividade = computed(() => {
    return !caracteristicas.value.every(caracteristica => verificarSeElementoTemConteudo(caracteristica.valor))
  })

  const fecharModal = (): void => {
    emissorVisibilidade.value = false
    resetarFormulario()
  }

  const resetarFormulario = (): void => {
    projetoSelecionado.value = null
    tipoDeAtividadeSelecionado.value = null
  }

  const filtrarProjetosQueUsuarioEhMembro = (): void => {
    projetos.value = projetos.value.filter((projeto) => {
      const membrosDoProjeto = projeto.membros.map((membro) => membro.idUsuario)

      return membrosDoProjeto.includes(idUsuarioLogado)
    })
  }

  const mapearProjetos = (): void => {
    projetosMapeados.value = projetos.value.map((projeto) => {
      return {
        id: projeto.id,
        nome: projeto.nomeProjeto,
        atividadesDoProjeto: projeto.atividadesDoProjeto
      }
    })
  }

  const buscarMaisProjetos = async (): Promise<void> => {
    await buscarMaisDados(lerProjetos, projetos, {
      chavesDosDados: ["id", "nomeProjeto", "atividadesDoProjeto", "membros"],
    })

    filtrarProjetosQueUsuarioEhMembro()
    mapearProjetos()
  }

  const listarProjetos = async (): Promise<void> => {
    await lerProjetos.executar()

    if (lerProjetos.resultado.status === "sucesso") {
      await atualizarDadosDoRepositorio(lerProjetos, projetos, {
        chavesDosDados: ["id", "nomeProjeto", "atividadesDoProjeto", "membros"]
      })

      filtrarProjetosQueUsuarioEhMembro()
      mapearProjetos()

    } else if (lerProjetos.resultado.status === "erro") {
      onErro({
        resumo: t("erroAoBuscarProjetos"),
        detalhes: t("ocorreuUmErroAoBuscarProjetos"),
      })
    } else if (lerProjetos.resultado.status === "vazio") {
      projetos.value = []
    }
  }

  const filtrarProjetos = async (valorInserido: string): Promise<void> => {
    await filtrarDadosDoRepositorio(valorInserido, lerProjetos, projetos, {
      chavesDosDados: ["id", "nomeProjeto", "atividadesDoProjeto", "membros"],
      chaveDoFiltro: "nome_projeto"
    })

    filtrarProjetosQueUsuarioEhMembro()
    mapearProjetos()
  }

  const extrairDadosDoProjetoSelecinoado = () => {
    return projetos.value.find((projeto) => projeto.id === projetoSelecionado.value)
  }

  const listarTiposDeAtividade = (): void => {
    const projeto = extrairDadosDoProjetoSelecinoado()

    if (projeto) {
      const atividadesDoProjeto = projeto.atividadesDoProjeto || []
      const possuiAtividadesDoProjeto = atividadesDoProjeto.length > 0

      if (possuiAtividadesDoProjeto) {
        atividadesDoProjeto.forEach((atividade) => {
          if (!atividade.id) {
            return
          }

          const tipoExistente = tiposDeAtividade.value.find(
            (item) => item.id === atividade.id
          )

          if (!tipoExistente) {
            tiposDeAtividade.value.push({
              id: atividade.id,
              idTipoDeAtividade: atividade.idTipoDeAtividade,
              nome: atividade.nome,
            })
          }
        })

        segundaEtapaModal.value = true
      } else {
        onAviso({
          resumo: t("projetoNaoPossuiAtividadesPlanejadas"),
          detalhes: t("selecioneOutroProjeto"),
        })
      }
    }
  }

  const listarAtributosEsperadosDoTipoDeAtividade = async (): Promise<void> => {
    const atividadeDoProjeto = tiposDeAtividade.value.find(
      (atividade) => atividade.id === tipoDeAtividadeSelecionado.value
    )
    if (!atividadeDoProjeto) {
      return
    }

    lerTiposDeAtividadeComAtributos.sobrescreverParametros({
      id: "igual." + atividadeDoProjeto.idTipoDeAtividade,
    })
    await lerTiposDeAtividadeComAtributos.executar()

    if (lerTiposDeAtividadeComAtributos.resultado.status === 'sucesso') {
      atributosEsperados.value = lerTiposDeAtividadeComAtributos.resultado.dados[0].atributosEsperados
    }

    if (lerTiposDeAtividadeComAtributos.resultado.status === "erro") {
      onErro({
        resumo: t("erroAoBuscarAtributos"),
        detalhes: t("ocorreuUmErroAoBuscarAtributos"),
      })
    }
  }

  const acaoBotaoSubmissor = async (): Promise<void> => {
    const tipoDeAtividadePossuiAtributos = caracteristicas.value.length > 0

    if (tipoDeAtividadeSelecionado.value && projetoSelecionado.value) {
      const atividadeDoProjeto = tiposDeAtividade.value.find(
        (atividade) => atividade.id === tipoDeAtividadeSelecionado.value
      )
      if (!atividadeDoProjeto) {
        return
      }

      estadoDeCarregamentoIniciarAtividade.value = estados.PEDENTE

      const argumentos: IniciarAtividadeRealizadaNaoPlanejada = {
        idTipoDeAtividade: atividadeDoProjeto.idTipoDeAtividade,
        idAtividadeDoProjeto: atividadeDoProjeto.id,
        idProjeto: projetoSelecionado.value,
        idAtividadePlanejada: null,
        modoDeRegistroInicio: "web",
        idProfissionalQueRealizou: idDoProfissionalLogado.value,
        timezone: obterTimeZoneLocal(),
      }

      if (tipoDeAtividadePossuiAtributos) {
      const caracteristicasSemValorPreenchido = !caracteristicas.value.every(caracteristica => verificarSeElementoTemConteudo(caracteristica.valor))

      if (caracteristicasSemValorPreenchido) {
        onInfo({
          resumo: t("atributosComValoresInvalidos"),
          detalhes: t("obrigatorioPreencherAtributos"),
        })
        return
      }
    }

    argumentos.listaDeAtributosCaracteristicaComValor = caracteristicas.value.map(caracteristica => ({
      id: caracteristica.id,
      valor: caracteristica.valor,
    }))

      escritorAtividade.mudarArgumentos([argumentos])
      await escritorAtividade.executar()

      resolver(escritorAtividade.resultado, {
        sucesso: () => {
          estadoDeCarregamentoIniciarAtividade.value = estados.SUCESSO
          onSucesso({
            resumo: t("atividadeIniciadaComSucesso"),
            detalhes: t("calendarioEstaSendoAtualizado"),
          })
          emitir("update:atualizarCalendario")
          fecharModal()
        },
        erro: () => {
          estadoDeCarregamentoIniciarAtividade.value = estados.ERRO
          onErro({
            resumo: t("erroAoIniciarAtividade"),
            detalhes: t("tenteNovamenteMaisTarde"),
          })
        },
      })
    }
  }

  onUnmounted(() => {
    caracteristicaStore.resetarCaracteristicas()
  })

  onMounted(async () => {
    await listarProjetos()
  })

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: _unref(emissorVisibilidade),
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_isRef(emissorVisibilidade) ? (emissorVisibilidade).value = $event : null)),
    class: "OIniciarAtividadeRealizadaNaoPlanejada",
    "data-testid": "OIniciarAtividadeRealizadaNaoPlanejada",
    draggable: false,
    modalw: "",
    style: { 'max-width': '550px', height: 'auto' }
  }, {
    header: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(_unref(t)('iniciarNovaAtividade')), 1)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_10, [
        (_unref(temAtributos) && etapaAtiva.value === 0)
          ? (_openBlock(), _createBlock(_unref(ABotaoDeAcao), {
              key: 0,
              onProximoPasso: avancarParaProximaEtapa,
              "esta-carregando": false,
              "fase-da-atividade": "proximoPasso"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_unref(AButton), {
                onClick: fecharModal,
                class: "OAtividadeNaoPlanejada__BotaoCancelar",
                "data-testid": "OAtividadeNaoPlanejada__BotaoCancelar",
                disabled: _unref(estaSalvandoAtividade),
                label: _unref(t)('voltar')
              }, null, 8, ["disabled", "label"]),
              _createVNode(_unref(AButton), {
                onClick: acaoBotaoSubmissor,
                class: "OAtividadeNaoPlanejada__Botao OAtividadeNaoPlanejada__BotaoSubmissor",
                "data-testid": "OAtividadeNaoPlanejada__BotaoSubmissor",
                disabled: _unref(botaoSubmissorEstaDesativado) || _unref(estaSalvandoAtividade) || _unref(estaCarregandoAtributos) || _unref(desabilitarBotaoIniciarAtividade),
                label: _unref(t)('iniciar'),
                loading: _unref(estaSalvandoAtividade)
              }, null, 8, ["disabled", "label", "loading"])
            ]))
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("main", _hoisted_2, [
        (_unref(estaCarregandoAtributos))
          ? (_openBlock(), _createBlock(_component_Skeleton, {
              key: 0,
              width: "50%",
              height: "2rem"
            }))
          : (_unref(deveExibirEtapas))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_unref(AEtapas), {
                  clicavel: "",
                  largura: "50%",
                  etapas: _unref(etapas),
                  "indice-ativo": etapaAtiva.value,
                  onEtapaClicada: aoClicarNaEtapa
                }, null, 8, ["etapas", "indice-ativo"])
              ]))
            : _createCommentVNode("", true),
        (etapaAtiva.value === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_unref(MDropdown), {
                  modelValue: projetoSelecionado.value,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => ((projetoSelecionado).value = $event)),
                    listarTiposDeAtividade
                  ],
                  onOnFiltrandoBusca: filtrarProjetos,
                  "buscar-mais-itens": buscarMaisProjetos,
                  carregando: _unref(estaCarregandoProjetos),
                  class: "OAtividadeNaoPlanejada__SelecionarProjeto",
                  "data-testid": "OAtividadeNaoPlanejada__SelecionarProjeto",
                  nome: "projetos",
                  "option-label": "nome",
                  "option-value": "id",
                  options: projetosMapeados.value,
                  placeholder: _unref(t)('projetos'),
                  "usar-carregamento-sob-demanda": "",
                  width: "478px"
                }, null, 8, ["modelValue", "carregando", "options", "placeholder"])
              ]),
              (segundaEtapaModal.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _hoisted_8,
                    _createVNode(_unref(MDropdown), {
                      modelValue: tipoDeAtividadeSelecionado.value,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => ((tipoDeAtividadeSelecionado).value = $event)),
                        listarAtributosEsperadosDoTipoDeAtividade
                      ],
                      class: "OAtividadeNaoPlanejada__TiposDeAtividade",
                      "data-testid": "OAtividadeNaoPlanejada__SelecionarTiposDeAtividade",
                      nome: "lanca-atividade",
                      "option-label": "nome",
                      "option-value": "id",
                      options: tiposDeAtividade.value,
                      placeholder: _unref(t)('tipoDeAtividade'),
                      width: "478px"
                    }, null, 8, ["modelValue", "options", "placeholder"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (etapaAtiva.value === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_unref(MFormularioAtividadeComAtributos), { atributosEsperados: atributosEsperados.value }, null, 8, ["atributosEsperados"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})